import { render, staticRenderFns } from "./TagsSection.vue?vue&type=template&id=f14ba92e&"
import script from "./TagsSection.vue?vue&type=script&lang=js&"
export * from "./TagsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports